// import React from 'react';

import AirCNC from './workData/AirCNC';
import PowerXGym from './workData/PowerXGym';
import DoctorsPortal from './workData/DoctorsPortal';
import RedOnion from './workData/RedOnion';
import HotGadgets from './workData/HotGadgets';
// import PandaECommerce from './workData/PandaECommerce';
import PersonalWebsite from './workData/PersonalWebsite';
// import WebPortfolio from './workData/WebPortfolio';
import CreativeDeveloper from './workData/CreativeDeveloper';
import TaxaWPTheme from './workData/TaxaWPTheme';
import TimerWPTheme from './workData/TimerWPTheme';
import BootstrapLandingPage from './workData/BootstrapLandingPage';
import MedicalConsult from './workData/MedicalConsult';
import HexagonLandingPage from './workData/HexagonLandingPage';
import Minima from './workData/Minima';
import AtlantixZen from './workData/AtlantixZen';
import PhotobookAsanov from './workData/PhotobookAsanov';
import WasekPortfolioSinglePage from './workData/WasekPortfolioSinglePage';
import Hu from './workData/Hu';
import WasekPortfolio from './workData/WasekPortfolio';
import FirstWPTheme from './workData/FirstWPTheme';
import Switch from './workData/Switch';
import TreehouseHomePage from './workData/TreehouseHomePage';
import FirstWebsite from './workData/FirstWebsite';

const workData = [
    // {
    //     id: 0, permalink: "permalink", thumb: Thumb, title: "Title", category: "Category", categoryURL: "CategoryURL", detailImg1: detailImg1, detailImg2: detailImg2, previewTxt: "Preview", previewURL: "PreviewURL", sourceTxt: "", sourceURL: "", description: <>
    //         <h3 class="mbSmall">Minimal is a Fully Responsive PSD To HTML Web Template.</h3>
    //         <p>&nbsp;</p>

    //         <h5>Main Feature:</h5>
    //         <ul>
    //             <li></li>
    //             <li></li>
    //             <li></li>
    //             <li></li>
    //             <li></li>
    //         </ul>

    //         <h5>Unfavorable:</h5>
    //         <ul>
    //             <li>No Responsive</li>
    //         </ul>
    //     </>
    // },

    AirCNC,
    PowerXGym,
    DoctorsPortal,
    RedOnion,
    HotGadgets,
    // PandaECommerce,
    PersonalWebsite,
    // WebPortfolio,
    CreativeDeveloper,
    TaxaWPTheme,
    TimerWPTheme,
    BootstrapLandingPage,
    MedicalConsult,
    HexagonLandingPage,
    Minima,
    AtlantixZen,
    PhotobookAsanov,
    WasekPortfolioSinglePage,
    Hu,
    WasekPortfolio,
    FirstWPTheme,
    Switch,
    TreehouseHomePage,
    FirstWebsite
]
export default workData;